export default __webpack_public_path__ + "3afd4e5d5c6c202176c7bd95b56c77b0.woff2";